module.exports = __webpack_public_path__ + "static/img/oppo1.f2311c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/oppo/oppo1.png
// module id = mHGd
// module chunks = 0